<template>
    <span ref="field"
          :id="inputId"
          @keyup.enter="enter()"
          @focus="focusContract()"
          @blur="blurContract()"
          :placeholder="placeholder"
          @input="updateValue($event.target.innerText);"
          @keydown.shift.enter.stop.prevent="addItem()"
          @keydown.enter.stop.prevent="nextItem()"
          class="pseudo-textarea"
          contenteditable="true"
    ></span>
</template>

<script>
export default {
    name: "EditableItemSimple",
    props: {
        value: {default: ''},
        placeholder: {default: 'Введите текст...'},
        inputId: {default: ''},
        disabled: {default: false},
        name: {default: 'name'},
        autoFocus: {default: false},
    },
    data(){
        return {
            contractFocus: false,
        }
    },
    computed: {

    },
    mounted() {
        this.$refs.field.innerText = this.value
        if(this.autoFocus === true) {
            this.inputFocus();
        }
    },
    methods: {
        focusContract(){
            this.$emit('focus');
        },
        blurContract(){
            this.$emit('blur');
        },
        updateValue(value){
            this.$emit('input',value)
        },
        enter: function () {
            this.$emit('enter');
        },
        nextItem: function () {
            this.$emit('next');
        },
        inputFocus() {
            if(!!this.$refs.field){
                this.$nextTick(() => {
                    this.$refs.field.focus()
                    if (typeof window.getSelection != "undefined"
                        && typeof document.createRange != "undefined") {
                        let range = document.createRange();
                        range.selectNodeContents(this.$refs.field);
                        range.collapse(false);
                        let sel = window.getSelection();
                        sel.removeAllRanges();
                        sel.addRange(range);
                    } else if (typeof document.body.createTextRange != "undefined") {
                        let textRange = document.body.createTextRange();
                        textRange.moveToElementText(this.$refs.field);
                        textRange.collapse(false);
                        textRange.select();
                    }
                });
            }
        },
        addItem(){
            this.$emit('push');
        },
        log(value){
            console.log(value)
        }
    }
}
</script>

<style scoped>

</style>